export const mergePropClasses = (props, classes) =>
  mergeClasses([props.class || props.className].concat(classes));

export const mergeClasses = (classes) =>
  classes.filter((element) => typeof element === "string").join(" ");

export const isUrlWithScheme = (link) => {
  const regex = /^(http:\/\/|https:\/\/|ftp:\/\/|mailto:|file:\/\/)/;
  return regex.test(link);
};
